// @flow

import _ from 'lodash';
import React, { Suspense, useEffect } from 'react';
import { connect } from 'react-redux';
import './App.css';
import eventTracker from './libs/event-tracker';
import { routes } from 'src/routes';
import { Switch, Route, useLocation } from 'react-router-dom';
import { I18nContext, I18nManager } from '@shopify/react-i18n';
import 'intl-pluralrules';
import queryString from 'query-string';

import Finalize from 'src/components/containers/finalize';
import Oauth from 'src/components/containers/oauth';
import KlaviyoCallback from 'src/components/containers/klaviyo/callback';
import {
  APP_LANGUAGE_PSEUDO_LOCALIZATION_VALUE,
  APP_LANGUAGE_ENGLISH_VALUE
} from 'src/constants/language-setting';
import { loadMomentLocale } from 'src/helpers/momentJS';

import { ShopifyEmbeddedAppRoute } from 'src/ShopifyEmbeddedAppRoute';
import Main from 'src/components/containers/main';
import I18nAppProvider from './i18n-app-provider';
import { saveHost } from 'src/integrations/shopify-app-bridge/app';
import MainMenu from 'src/components/containers/main-menu';
import {
  Card,
  Layout,
  Page,
  SkeletonBodyText,
  SkeletonDisplayText,
  TextContainer
} from '@shopify/polaris';

function App(props) {
  const { appLanguage } = props;
  const pseudolocalize = appLanguage === APP_LANGUAGE_PSEUDO_LOCALIZATION_VALUE;
  const i18nManager = new I18nManager({
    locale: pseudolocalize ? APP_LANGUAGE_ENGLISH_VALUE : appLanguage,
    pseudolocalize,
    onError(error) {
      alert(error);
    }
  });
  const location = useLocation();

  useEffect(() => {
    // Save hostname for Shopify App Bridge
    const queries = queryString.parse(location.search);
    let { host, shop } = queries;
    // Fix issue: missing host on URL when accessing page
    if (_.isEmpty(host)) {
      host = btoa(`${shop}/admin`);
    }

    saveHost(host);
  }, []);

  useEffect(() => {
    // Initialize EventTracker
    eventTracker.addEventListeners();
    eventTracker.handleEvents();
  }, []);

  loadMomentLocale(appLanguage);

  return (
    <div className={`BC-Lang__${appLanguage}`}>
      <I18nContext.Provider value={i18nManager}>
        <I18nAppProvider>
          <Suspense
            fallback={
              <>
                <MainMenu />
                <Page>
                  <div className="BC-Fallback">
                    <div className="BC-Fallback__Header">
                      <SkeletonDisplayText size="large" />
                      <SkeletonDisplayText size="large" />
                    </div>
                    <Layout>
                      <Layout.Section>
                        <Card sectioned>
                          <SkeletonBodyText />
                        </Card>
                        <Card sectioned>
                          <TextContainer>
                            <SkeletonDisplayText size="small" />
                            <SkeletonBodyText />
                          </TextContainer>
                        </Card>
                        <Card sectioned>
                          <TextContainer>
                            <SkeletonDisplayText size="small" />
                            <SkeletonBodyText />
                          </TextContainer>
                        </Card>
                      </Layout.Section>
                    </Layout>
                  </div>
                </Page>
              </>
            }>
            <Switch>
              <ShopifyEmbeddedAppRoute
                path={routes.finalize.view()}
                pageName={'Finalize'}
                render={p => <Finalize {...p} />}
              />
              <Route path={routes.oauth.view()} render={p => <Oauth {...p} />} />
              <Route
                exact
                path={routes.integration.klaviyo.callback()}
                render={p => <KlaviyoCallback {...p} />}
              />
              <Route component={Main} />
            </Switch>
          </Suspense>
        </I18nAppProvider>
      </I18nContext.Provider>
    </div>
  );
}

const mapStateToProps = state => ({
  appLanguage: _.get(state.oauth.tenantApp, 'appLanguage', APP_LANGUAGE_ENGLISH_VALUE)
});

export default connect(mapStateToProps)(App);
